module.exports = __webpack_public_path__ + "ico-calendar.png?520e84dc920594069be0b2cfd57d4a77";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ico-calendar.png
// module id = 195
// module chunks = 0